import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../authContextProvider";
import {
  backBtn,
  carouselImgFive,
  carouselImgFour,
  carouselImgOne,
  carouselImgSix,
  carouselImgThree,
  carouselImgTwo,
  carouselImgSeven,
  carouselImgEight,
  carouselImgNine,
  carouselImgTen,
  dailyWinner,
  dailyWinnerInactive,
  diwaliBlast,
  diwaliDhamakaImg,
  homepageWinnerHeadingOne,
  homepageWinnerHeadingTwo,
  homepageWinnerHeadingThree,
  homepageAwardCategoryHeading,
  leaderboardHeadingOne,
  leaderboardHeadingTwo,
  leaderboardHeadingThree,
  leaderboardHeadingFour,
  leaderboardHeadingFive,
  leaderboardHeadingSix,
  // leaderboardHeadingSeven,
  // leaderboardHeadingEight,
  // rewardCategoryEight,
  rewardCategoryFive,
  rewardCategoryFour,
  rewardCategoryOne,
  // rewardCategorySeven,
  rewardCategorySix,
  rewardCategoryThree,
  rewardCategoryTwo,
  termsAndConditions,
  weeklyWinner,
  winnerDiwaliDhamakaImg,
  winnersHeading,
} from "./constants";

import {
  carouselImgFiveHi,
  carouselImgFourHi,
  carouselImgOneHi,
  carouselImgSixHi,
  carouselImgThreeHi,
  carouselImgTwoHi,
  carouselImgEightHi,
  carouselImgSevenHi,
  carouselImgNineHi,
  carouselImgTenHi,
  dailyWinnerHi,
  homepageWinnerHeadingOneHi,
  homepageWinnerHeadingTwoHi,
  homepageWinnerHeadingThreeHi,
  homepageAwardCategoryHeadingHi,
  leaderboardHeadingOneHi,
  leaderboardHeadingTwoHi,
  leaderboardHeadingThreeHi,
  leaderboardHeadingFourHi,
  leaderboardHeadingFiveHi,
  leaderboardHeadingSixHi,
  // leaderboardHeadingSevenHi,
  // leaderboardHeadingEightHi,
  dailyWinnerInactiveHi,
  diwaliDhamakaImgHi,
  // rewardCategoryEightHi,
  rewardCategoryFiveHi,
  rewardCategoryFourHi,
  rewardCategoryOneHi,
  // rewardCategorySevenHi,
  rewardCategorySixHi,
  rewardCategoryThreeHi,
  rewardCategoryTwoHi,
  termsAndConditionsHi,
  weeklyWinnerHi,
  winnerDiwaliDhamakaImgHi,
  winnersHeadingHi,
} from "./constants";

type homePageDataType = {
  diwaliDhamakaImg: string;
  winnersHeading: string;
  dailyWinner: string;
  dailyWinnerInactive: string;
  weeklyWinner: string;
  termsAndConditions: string;
  diwaliBlast: string;
  rewardCategoryOne: string;
  rewardCategoryTwo: string;
  rewardCategoryThree: string;
  rewardCategoryFour: string;
  rewardCategoryFive: string;
  rewardCategorySix: string;
  // rewardCategorySeven: string;
  // rewardCategoryEight: string;
  homepageWinnerHeadingOne: string;
  homepageWinnerHeadingTwo: string;
  homepageWinnerHeadingThree: string;
  homepageAwardCategoryHeading: string;
};

type carouselDataType = {
  carouselImgOne: string;
  carouselImgTwo: string;
  carouselImgThree: string;
  carouselImgFour: string;
  carouselImgFive: string;
  carouselImgSix: string;
  carouselImgSeven: string;
  carouselImgEight: string;
  carouselImgNine: string;
  carouselImgTen: string;
};

type winnerPageDataType = {
  winnerDiwaliDhamakaImg: string;
  termsAndConditions: string;
  dailyWinnerHeading: string;
  weeklyWinnerHeading: string;
  dailyWinnerHeadingInactive: string;
  backBtn: string;
};

type leaderboardPageDataType = {
  winnerDiwaliDhamakaImg: string;
  termsAndConditions: string;
  leaderboardHeadingOne: string;
  leaderboardHeadingTwo: string;
  leaderboardHeadingThree: string;
  leaderboardHeadingFour: string;
  leaderboardHeadingFive: string;
  leaderboardHeadingSix: string;
  // leaderboardHeadingSeven: string;
  // leaderboardHeadingEight: string;
  backBtn: string;
};

const useDiwaliHook = () => {
  const [homepageData, setHomepageData] = useState<homePageDataType>();
  const [carouselData, setCarouselData] = useState<carouselDataType>();
  const [winnerPageData, setWinnerPageData] = useState<winnerPageDataType>();
  const [leaderboardPageData, setLeaderboardPageData] =
    useState<leaderboardPageDataType>();
  const { trackEvent, userData }: any = useAuthContext();
  const lang = userData?.lang;
  let navigate = useNavigate();

  useEffect(() => {
    document.title = "JUST retailers contest";
  }, []);

  useEffect(() => {
    if (userData?.lang === "hi") {
      setHomepageData({
        diwaliDhamakaImg: diwaliDhamakaImgHi,
        winnersHeading: winnersHeadingHi,
        dailyWinner: dailyWinnerHi,
        dailyWinnerInactive: dailyWinnerInactiveHi,
        weeklyWinner: weeklyWinnerHi,
        termsAndConditions: termsAndConditionsHi,
        diwaliBlast,
        rewardCategoryOne: rewardCategoryOneHi,
        rewardCategoryTwo: rewardCategoryTwoHi,
        rewardCategoryThree: rewardCategoryThreeHi,
        rewardCategoryFour: rewardCategoryFourHi,
        rewardCategoryFive: rewardCategoryFiveHi,
        rewardCategorySix: rewardCategorySixHi,
        // rewardCategorySeven: rewardCategorySevenHi,
        // rewardCategoryEight: rewardCategoryEightHi,
        homepageWinnerHeadingOne: homepageWinnerHeadingOneHi,
        homepageWinnerHeadingTwo: homepageWinnerHeadingTwoHi,
        homepageWinnerHeadingThree: homepageWinnerHeadingThreeHi,
        homepageAwardCategoryHeading: homepageAwardCategoryHeadingHi,
      });
      setWinnerPageData({
        winnerDiwaliDhamakaImg: winnerDiwaliDhamakaImgHi,
        termsAndConditions,
        dailyWinnerHeading: homepageWinnerHeadingOneHi,
        dailyWinnerHeadingInactive: homepageWinnerHeadingTwoHi,
        weeklyWinnerHeading: homepageWinnerHeadingThreeHi,
        backBtn,
      });
      setLeaderboardPageData({
        winnerDiwaliDhamakaImg: winnerDiwaliDhamakaImgHi,
        termsAndConditions,
        leaderboardHeadingOne: leaderboardHeadingOneHi,
        leaderboardHeadingTwo: leaderboardHeadingTwoHi,
        leaderboardHeadingThree: leaderboardHeadingThreeHi,
        leaderboardHeadingFour: leaderboardHeadingFourHi,
        leaderboardHeadingFive: leaderboardHeadingFiveHi,
        leaderboardHeadingSix: leaderboardHeadingSixHi,
        // leaderboardHeadingSeven: leaderboardHeadingSevenHi,
        // leaderboardHeadingEight: leaderboardHeadingEightHi,
        backBtn,
      });
      setCarouselData({
        carouselImgOne: carouselImgOneHi,
        carouselImgTwo: carouselImgTwoHi,
        carouselImgThree: carouselImgThreeHi,
        carouselImgFour: carouselImgFourHi,
        carouselImgFive: carouselImgFiveHi,
        carouselImgSix: carouselImgSixHi,
        carouselImgSeven: carouselImgSevenHi,
        carouselImgEight: carouselImgEightHi,
        carouselImgNine: carouselImgNineHi,
        carouselImgTen: carouselImgTenHi,
      });
    } else {
      setHomepageData({
        diwaliDhamakaImg,
        winnersHeading,
        dailyWinner,
        dailyWinnerInactive,
        weeklyWinner,
        termsAndConditions,
        diwaliBlast,
        rewardCategoryOne,
        rewardCategoryTwo,
        rewardCategoryThree,
        rewardCategoryFour,
        rewardCategoryFive,
        rewardCategorySix,
        // rewardCategorySeven,
        // rewardCategoryEight,
        homepageWinnerHeadingOne: homepageWinnerHeadingOneHi,
        homepageWinnerHeadingTwo: homepageWinnerHeadingTwoHi,
        homepageWinnerHeadingThree,
        homepageAwardCategoryHeading,
      });
      setWinnerPageData({
        winnerDiwaliDhamakaImg,
        termsAndConditions,
        dailyWinnerHeading: homepageWinnerHeadingOne,
        dailyWinnerHeadingInactive: homepageWinnerHeadingTwo,
        weeklyWinnerHeading: homepageWinnerHeadingThree,
        backBtn,
      });
      setLeaderboardPageData({
        winnerDiwaliDhamakaImg,
        termsAndConditions,
        leaderboardHeadingOne,
        leaderboardHeadingTwo,
        leaderboardHeadingThree,
        leaderboardHeadingFour,
        leaderboardHeadingFive,
        leaderboardHeadingSix,
        // leaderboardHeadingSeven,
        // leaderboardHeadingEight,
        backBtn,
      });
      setCarouselData({
        carouselImgOne,
        carouselImgTwo,
        carouselImgThree,
        carouselImgFour,
        carouselImgFive,
        carouselImgSix,
        carouselImgSeven,
        carouselImgEight,
        carouselImgNine,
        carouselImgTen,
      });
    }
  }, [userData?.lang]);

  const handleBackBtn = () => {
    navigate(-1);
  };

  return {
    homepageData,
    winnerPageData,
    leaderboardPageData,
    carouselData,
    handleBackBtn,
    trackEvent,
    lang,
  };
};

export default useDiwaliHook;
